<div class="map-container">
  <google-map  [options]="mapOptions" (mapClick)="onMapClick($event)">
   
          <map-marker [position]="marker"></map-marker>
    
  </google-map>
</div>